<template>
  <app-page>
    <div id="wrap">
      <h2 class="h2">国家规划布局内重点软件企业减按10%税率征收企业所得税</h2>
      <div class="header_box">
        <span class="span_btn">政策依据</span>
        <!-- <span
          >关于完善研究开发费用税前加计扣除政策的通知
          <i class="iconfont icon-jiantoudown"></i
        ></span>-->
        <div class="zice_btn">
          <span @click="centerDialogFn()">
            立即自测
            <i class="iconfont icon-arrow-right-copy-copy"></i>
          </span>
        </div>
      </div>

      <el-dialog
        custom-class="dialog"
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="26%"
        center
        @close="dialogType = 0"
      >
        <template v-if="dialogType === 1">
          <div class="text_box">
            根据您的数据，您的匹配度为:
            <h2 class="title" style="display: inline" id="status">
              {{ status }}
            </h2>
          </div>
          <br />
          <div class="flex flex-center">
            <img src="@images/icon/res.png" alt />
          </div>
          <h2 class="title" style="text-align: center" id="msg1">{{ msg1 }}</h2>
          <div
            id="msg2"
            class="subtitle pointer wrap"
            style="
              text-align: center;
              margin-top: 15px;
              line-height: normal;
              white-space: pre-wrap !important;
            "
          >
            {{ msg2 }}
          </div>
          <br />
          <div style="font-size: 12px">
            <span style="color: red">温馨提示:</span>
            <span style="color: darkgray; line-height: 15px"
              >政策自测结果仅供参考，请申报单位参考当地申报通知进行申报</span
            >
          </div>
        </template>
        <template v-else>
          <div class="flex flex-center zice_gif">
            <img src="@images/icon/zice.gif" />
          </div>
        </template>
        <template #footer>
          <template v-if="dialogType === 0"></template>
          <template v-else>
            <span class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false"
                >确认</el-button
              >
            </span>
          </template>
        </template>
      </el-dialog>

      <div class="title_box">
        <span class="backg">!</span>
        <span>带*的信息尤为重要,严重影响自测结果,请您务必填写!</span>
      </div>
      <div class="answer">
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>1，企业法人资格（单选）</span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic1"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio1"
              @change="changefn1"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio1 == 0 ? '#4988df' : 'red' }"
          >
            {{ text1 }}
          </div>
        </div>
        <!--  -->
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >2，申报单位是否属于国家规划布局内的重点软件企业 （ 单选 ）</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic2"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio2"
              @change="changefn2"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio2 == 0 ? '#4988df' : 'red' }"
          >
            {{ text2 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span
              >3，申报单位是否以软件产品开发销售（营业）为主营业务 （ 单选
              ）</span
            >
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic3"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio3"
              @change="changefn3"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio3 == 0 ? '#4988df' : 'red' }"
          >
            {{ text3 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              4，申报单位主营业务是否拥有自主
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    高新技术企业认定中，对企业知识产权情况采用分类评价方式，其中:发明专利（(含国防专利)、植物新品种、国家级农作物品种、国家新药、国家—级中药保护品种、集成电路布图设计专有权等按Ⅰ类评价;实用新型专利、外观设计专利、软件著作权等(不含商标)按Ⅱ类评价。按Ⅱ类评价的知识产权在申请高新技术企业时，仅限使用一次。
                  </div>
                  <div class="tip_content">
                    在申请高新技术企业及高新技术企业资格存续期内，知识产权有多个权属人时，只能由一个权属人在申请时使用。申请认定时专利的有效性以企业申请认定前获得授权证书或授权通知书并能提供缴费收据为准。
                  </div>
                </template>
                <span class="keyword">知识产权</span> </el-tooltip
              >（ 单选 ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic4"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio4"
              @change="changefn4"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio4 == 0 ? '#4988df' : 'red' }"
          >
            {{ text4 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              5，
              汇算清缴年度具有劳动合同关系且具有大学专科以上学历的职工人数占企业月平均职工总人数的比例为（
              ）%
            </span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input1"
              @input="inputfn1"
            ></el-input>
            <span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input1 >= 40 ? '#4988df' : 'red' }"
          >
            {{ text5 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              6，汇算清缴年度软件企业研究开发人员占企业月平均
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    企业职工总数包括企业在职、兼职和临时聘用人员。在职人员可以通过企业是否签订了劳动合同或缴纳社会保险费来鉴别;兼职、临时聘用人员全年须在企业累计工作183天以上。
                  </div>
                </template>

                <span class="keyword">职工总数</span> </el-tooltip
              >的比例为（ ）%
            </span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input2"
              @input="inputfn2"
            ></el-input>
            <span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input2 >= 20 ? '#4988df' : 'red' }"
          >
            {{ text6 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              7，汇算清缴年度研究开发费用总额占
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    软件企业销售（营业）收入总额包括营业收入(含主营业务收入和其他业务收入）、视同销售收入(包括非货币性交易视同销售收入、货物财产劳务视同销售收入和其他视同销售收入)。
                  </div>
                </template>

                <span class="keyword"
                  >软件企业销售（营业）收入总额</span
                > </el-tooltip
              >的比例为（ ）%
            </span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input3"
              @input="inputfn3"
            ></el-input>
            <span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input3 >= 6 ? '#4988df' : 'red' }"
          >
            {{ text7 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              8，
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    软件企业在中国境内发生的研究开发费用，是指企业内部研究开发活动实际支出的全部费用与委托境内的企业、大学、研究机构、技术专业服务机构等进行的研究开发活动所支出的，以及受托研究开发中形成本企业无形资产的费用之和，不包括委托境外机构完成的研究开发活动所发生的费用。具体包括:1.新产品设计费、新工艺规程制定费以及与研发活动直接相关的技术图书资料费、资料翻译费。.从事研发活动直接消耗的材料、燃料和动力费用。3.在职直接从事研发活动人员的工资、薪金、奖金、津贴、补贴。4.专门用于研发活动的仪器、设备的折旧费或租赁费。5.专门用于研发活动的软件、专利权、非专利技术等无形资产的摊销费用。6.专门用于中间试验和产品试制的模具、工艺装备开发及制造费。7.勘探开发技术的现场试验费。8.研发成果的论证、评审、验收费用。
                  </div>
                </template>

                <span class="keyword"
                  >软件企业中国境内发生的研究开发费用</span
                > </el-tooltip
              >占研究开发费用总额的比例为（ ）%
            </span>
          </div>
          <div class="item">
            <el-input
              placeholder="请输入数字"
              style="width: 150px"
              v-model="input4"
              @input="inputfn4"
            ></el-input>
            <span>（输入）</span>
          </div>
          <div
            class="title"
            :style="{ color: input4 >= 60 ? '#4988df' : 'red' }"
          >
            {{ text8 }}
          </div>
        </div>
        <!--  -->
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              9，申报单位是否完全满足下列条件：汇算清缴年度
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    软件企业的软件产品开发销售（营业)收入，是指软件企业从事计算机软件、信息系统或嵌入式软件等软件产品开发并销售的收入，以及信息系统集成服务、信息技术咨询服务、数据处理和存储服务等技术服务收入。
                  </div>
                </template>

                <span class="keyword"
                  >软件企业的软件产品开发销售（营业）收入</span
                > </el-tooltip
              >占企业收入总额的比例大于等于50%（注：如含嵌入式软件产品和信息系统集成产品，则此类产品开发销售（营业）收入占企业收入总额的比例须大于等于40%）
              （ 单选 ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic5"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio5"
              @change="changefn5"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio5 == 0 ? '#4988df' : 'red' }"
          >
            {{ text9 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              10，申报单位是否完全满足下列条件：汇算清缴年度
              <el-tooltip class="item" effect="light" placement="bottom-start">
                <template #content>
                  <div class="tip_title">百科</div>
                  <div class="tip_content">
                    软件企业的软件产品自主开发销售（营业)收入，是指企业拥有自主知识产权的软件产品的开发销售（营业)收入。
                  </div>
                </template>

                <span class="keyword"
                  >软件企业的软件产品自主开发销售（营业）收入</span
                > </el-tooltip
              >占企业收入总额的比例大于等于40%（注：如含嵌入式软件产品和信息系统集成产品，则此类产品自主开发销售（营业）收入占企业收入总额的比例须大于等于30%）
              （ 单选 ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic6"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio6"
              @change="changefn6"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio6 == 0 ? '#4988df' : 'red' }"
          >
            {{ text10 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>11，申报单位符合情形 （ 单选 ）</span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic7"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio7"
              @change="changefn7"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio7 != 4 ? '#4988df' : 'red' }"
          >
            {{ text11 }}
          </div>
        </div>

        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              12，申报单位是否拥有核心关键技术，并以此为基础开展经营活动 （ 单选
              ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic8"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio8"
              @change="changefn8"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio8 == 0 ? '#4988df' : 'red' }"
          >
            {{ text12 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              13，申报单位是否具有与软件开发相适应软硬件设施等开发环境（如合法的开发工具等）
              （ 单选 ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic9"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio9"
              @change="changefn9"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio9 == 0 ? '#4988df' : 'red' }"
          >
            {{ text13 }}
          </div>
        </div>
        <div class="item_box">
          <div class="topic">
            <span class="color">*</span>
            <span>
              14，申报单位汇算清缴年度是否发生重大安全、重大质量事故或严重环境违法行为
              （ 单选 ）
            </span>
          </div>
          <div class="item">
            <el-radio
              v-for="item in topic10"
              :key="item.value"
              :label="item.value"
              border
              v-model="radio10"
              @change="changefn10"
              >{{ item.label }}</el-radio
            >
          </div>
          <div
            class="title"
            :style="{ color: radio10 == 1 ? '#4988df' : 'red' }"
          >
            {{ text14 }}
          </div>
        </div>
      </div>
      <div class="flex flex-center">
        <div class="zice_btn">
          <span @click="centerDialogFn()">
            立即自测
            <i class="iconfont icon-arrow-right-copy-copy"></i>
          </span>
        </div>
      </div>
    </div>
  </app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";
export default {
  components: { AppPage },
  data() {
    return {
      msg1: "",
      msg2: "",
      form: {
        region: "1",
      },
      accordScore: 140,
      status: "",
      dialogVisible: false,
      dialogType: 0,
      dialogTitle: "",
      // {label:"",value:0}
      topic1: [
        { label: "具有独立法人资格", value: 0 },
        { label: "不具有独立法人资格", value: 1 },
      ],
      topic2: [
        { label: "是", value: 0 },
        { label: "否", value: 1 },
      ],
      topic3: [
        { label: "是", value: 0 },
        { label: "否", value: 1 },
      ],
      topic4: [
        { label: "拥有", value: 0 },
        { label: "不拥有", value: 1 },
      ],
      topic5: [
        { label: "满足", value: 0 },
        { label: "不满足", value: 1 },
      ],
      topic6: [
        { label: "满足", value: 0 },
        { label: "不满足", value: 1 },
      ],
      topic7: [
        {
          label:
            "汇算清缴年度软件产品开发销售（营业）收入大于等于2亿元，应纳税所得额大于等于1000万元，研究开发人员占企业月平均职工总数的比例大于等于25%",
          value: 0,
        },
        {
          label:
            "在国家规定的重点软件领域内，汇算清缴年度软件产品开发销售（营业）收入大于等于5000万元，应纳税所得额大于等于250万元，研究开发人员占企业月平均职工总数的比例大于等于25%，企业在中国境内发生的研究开发费用金额占研究开发费用总额的比例大于等于70%",
          value: 1,
        },
        {
          label:
            "汇算清缴年度软件产品开发销售（营业）收入大于等于2亿元，应纳税所得额大于等于1000万元，研究开发人员占企业月平均职工总数的比例大于等于25%",
          value: 2,
        },
        {
          label:
            "汇算清缴年度软件出口收入总额大于等于800万美元，软件出口收入总额占本企业年度收入总额比例大于等于50%，研究开发人员占企业月平均职工总数的比例大于等于25%",
          value: 3,
        },
        { label: "以上情形无", value: 4 },
      ],
      topic8: [
        { label: "是", value: 0 },
        { label: "否", value: 1 },
      ],
      topic9: [
        { label: "具有", value: 0 },
        { label: "不具有", value: 1 },
      ],
      topic10: [
        { label: "发生", value: 0 },
        { label: "不发生", value: 1 },
      ],

      // 单选框
      radio1: 9,
      radio2: 9,
      radio3: 9,
      radio4: 9,
      radio5: 9,
      radio6: 9,
      radio7: 9,
      radio8: 9,
      radio9: 9,
      radio10: 9,

      // 提示信息
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
      text6: "",
      text7: "",
      text8: "",
      text9: "",
      text10: "",
      text11: "",
      text12: "",
      text13: "",
      text14: "",
      // 输入框
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      time: "",
    };
  },
  methods: {
    toService() {
      this.$router.push({
        path: "/detail/market",
        query: {
          goodId: "825d8eb0957b4a44927196b63818e8a2",
        },
      });
    },
    // 自测弹出框
    centerDialogFn() {
      if (
        this.radio1 == 9 ||
        this.radio2 == 9 ||
        this.radio3 == 9 ||
        this.radio4 == 9 ||
        this.radio5 == 9 ||
        this.radio6 == 9 ||
        this.radio7 == 9 ||
        this.radio8 == 9 ||
        this.radio9 == 9 ||
        this.radio10 == 9 ||
        this.input1 == "" ||
        this.input2 == "" ||
        this.input3 == "" ||
        this.input4 == ""
      ) {
        this.$message.error("请将带*的题目填写完成");
      } else {
        this.typefn();
        this.dialogTitle = "计算中";
        this.dialogVisible = true;
        this.dialogType = 0;
        this.time = setTimeout(this.timer, 3000);
      }
    },
    timer: function () {
      this.dialogTitle = "自测结果";
      this.dialogType = 1;
    },

    typefn: function () {
      this.accordScore = 140;

      if (this.radio1 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio2 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio3 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio4 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio5 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio6 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio7 == 4) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio8 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio9 == 1) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.radio10 == 0) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input1 < 40) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input2 < 20) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input3 < 6) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }
      if (this.input4 < 60) {
        this.accordScore = parseInt(this.accordScore) - 210;
      }

      console.log(this.accordScore);
      if (this.accordScore > 0) {
        this.status = "高";
        this.msg1 = "太棒了，恭喜您!";
        this.msg2 = "根据测评结果，建议申报！";
      } else {
        this.status = "低";
        this.msg1 = "再接再厉!";
        this.msg2 =
          "您的自测分值较低，未达到申报基本条件，尝试其他项目或完善信息吧！";
      }
    },

    changefn1: function (e) {
      console.log(e);
      if (e == "0") {
        this.text1 = "注: 符合";
      } else if (e == "1") {
        this.text1 =
          "注: 不符合，不具有独立法人资格的申报单位，不是企业所得税纳税人，不能享受优惠。";
      }
    },
    changefn2: function (e) {
      console.log(e);
      if (e == "0") {
        this.text2 = "注: 符合";
      } else {
        this.text2 =
          "注: 不符合，本政策适用于符合条件的国家规划布局内的重点软件企业。";
      }
    },
    changefn3: function (e) {
      console.log(e);
      if (e == "0") {
        this.text3 = "注: 符合";
      } else {
        this.text3 =
          "注: 不符合，本政策适用于以软件产品开发销售（营业）为主营业务的企业。";
      }
    },
    changefn4: function (e) {
      console.log(e);
      if (e == "0") {
        this.text4 = "注: 符合";
      } else {
        this.text4 = "注: 不符合，主营业务须拥有自主知识产权。";
      }
    },
    changefn5: function (e) {
      console.log(e);
      if (e == "0") {
        this.text9 = "注: 符合";
      } else {
        this.text9 =
          "注: 不符合，汇算清缴年度软件产品开发销售（营业）收入占企业收入总额的比例不低于50%（嵌入式软件产品和信息系统集成产品开发销售（营业）收入占企业收入总额的比例不低于40%）。";
      }
    },
    changefn6: function (e) {
      console.log(e);
      if (e == "1") {
        this.text10 =
          "注: 不符合，软件产品自主开发销售（营业）收入占企业收入总额的比例不低于40%（嵌入式软件产品和信息系统集成产品开发销售（营业）收入占企业收入总额的比例不低于30%）。";
      } else {
        this.text10 = "注: 符合";
      }
    },
    changefn7: function (e) {
      console.log(e);
      if (e == "4") {
        this.text11 =
          "注: 不符合，国家规划布局内重点软件企业应至少符合上述条件中的一项。";
      } else {
        this.text11 = "注: 符合";
      }
    },
    changefn8: function (e) {
      console.log(e);
      if (e == "0") {
        this.text12 = "注: 符合";
      } else {
        this.text12 =
          "注: 不符合，须拥有核心关键技术，并以此为基础开展经营活动。";
      }
    },
    changefn9: function (e) {
      console.log(e);
      if (e == "0") {
        this.text13 = "注: 符合";
      } else {
        this.text13 =
          "注: 不符合，必须具有与软件开发相适应软硬件设施等开发环境（如合法的开发工具等）。";
      }
    },
    changefn10: function (e) {
      console.log(e);
      if (e == "1") {
        this.text14 = "注: 符合";
      } else {
        this.text14 =
          "注: 不符合，要求申报单位汇算清缴年度未发生重大安全、重大质量事故或严重环境违法行为。";
      }
    },

    inputfn1: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 40) {
        this.text5 =
          "注: 不符合，汇算清缴年度具有劳动合同关系且具有大学专科以上学历的职工人数占企业月平均职工总人数的比例不低于40%。";
      } else if (parseInt(e) >= 40 && parseInt(e) <= 100) {
        this.text5 = "注：符合";
      } else {
        this.text5 = "";
      }
    },

    inputfn2: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 20) {
        this.text6 =
          "注: 不符合，研究开发人员占企业月平均职工总数的比例不低于20%。";
      } else if (parseInt(e) >= 20 && parseInt(e) <= 100) {
        this.text6 = "注：符合";
      } else {
        this.text6 = "";
      }
    },
    inputfn3: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 6) {
        this.text7 =
          "注: 不符合，汇算清缴年度研究开发费用总额占企业销售（营业）收入总额的比例不低于6%。";
      } else if (parseInt(e) >= 6 && parseInt(e) <= 100) {
        this.text7 = "注：符合";
      } else {
        this.text7 = "";
      }
    },
    inputfn4: function (e) {
      console.log(parseInt(e));
      if (parseInt(e) < 60) {
        this.text8 =
          "注: 不符合，企业在中国境内发生的研究开发费用金额占研究开发费用总额的比例不低于60%。";
      } else if (parseInt(e) >= 60 && parseInt(e) <= 100) {
        this.text8 = "注：符合";
      } else {
        this.text8 = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.h2 {
  color: #4988df;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.header_box {
  padding-bottom: 20px;
  border-bottom: 2px solid #4988df;
}
.span_btn {
  padding: 5px;
  border: 1px solid #4988df;
  color: #4988df;
  margin-right: 10px;
}
.zice_btn {
  color: #fff;
  background: #4988df;
  padding: 8px 22px;
  border-radius: 3px;
  float: right;
}
.title_box {
  margin-top: 15px;
  padding: 10px;
  border: 1px solid #f8cf96;
  background: #fff9ec;
}
.topic {
  line-height: 24px;
}
.item {
  /deep/ .el-radio {
    max-height: 100px;
    height: auto;
    padding: 12px 20px;
    .el-radio__label {
      line-height: 24px;
    }
  }
}
.title_box .backg {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  color: #fff;
  margin-right: 10px;
  background: #efc28a;
}
.answer {
  padding: 18px;
  font-size: 15px;
}
.answer .color {
  color: #d16963;
}
.answer .item {
  margin-left: 30px;
  /* margin-top: 15px; */
}
.answer .item_box {
  padding: 20px 0;
  border-bottom: 1px solid #dbdbdb;
}
.answer .el-button {
  margin-bottom: 10px;
}
.active {
  background-color: #d16963;
  color: #fff;
}
.answer .el-radio,
.answer .el-input,
.answer .el-checkbox {
  margin-top: 15px;
}
.title {
  margin: 15px 0 0 30px;
  color: #c40311;
}
.el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
/deep/.el-dialog__header {
  background: #4988df;
  padding: 20px 20px 10px;
}
/deep/.el-dialog__title {
  color: #fff;
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  color: black;
}
</style>
<style lang="scss" scoped>
.app-img {
  position: relative;
  height: 220px;
  line-height: 220px;
  padding-left: 60px;
  width: 100%;
  background-image: url("~@/assets/images/bg/apply.png");
  background-size: 100% 100%;
}
.app-title {
  color: $white;
  margin-bottom: 30px;
  font-size: 36px;
}
.app-content {
  box-sizing: border-box;
  background: $white;
  z-index: 999;
  padding: 50px 100px;
  // margin-bottom: 30px;
}
</style>
